import { AbstractPreparePurchase } from './AbstractPreparePurchase.es.js';

class AssetPreparePurchase extends AbstractPreparePurchase {
    constructor() {
        super(...arguments);
        this.invoicePreview = null;
        this.isAvailable = false;
        this.isOffline = null;
        this.productCode = null;
        this.productSegment = null;
        this.reasonCode = null;
        // Corresponds to the remaining quantity NOT INCLUDING current invoicePreview
        this.remainingFreeQuantity = null;
    }
}
const keysOfAssetPreparePurchase = ["invoicePreview", "isAvailable", "isOffline", "productCode", "productSegment", "reasonCode", "remainingFreeQuantity", "token", "hasPaymentMethod", "hasValidBillingAddress"];

export { AssetPreparePurchase, keysOfAssetPreparePurchase };
